// extracted by mini-css-extract-plugin
module.exports = {"link":"CheckoutForm_link__3b_ae"};